import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import ja from './locales/ja.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import es from './locales/es.json';
import pt from './locales/pt.json';
import zh from './locales/zh.json';
import ko from './locales/ko.json';
import zhHant from './locales/zhHant.json';
import fil from './locales/fil.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
      es: { translation: es },
      ja: { translation: ja },
      fr: { translation: fr },
      pt: { translation: pt },
      zh: { translation: zh },
      ko: { translation: ko },
      zhHant: { translation: zhHant },
      fil: { translation: fil },
    },
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

export default i18n;
